import React, { useState, useEffect } from "react";
import Sidebar from "../components/sidebar/Sidebar";
import Cdr from "../components/cdr/Cdr";

const CdrList = () => {
  const [isCdrPermitted, setIsCdrPermitted] = useState(false);

  useEffect(() => {
    const cdr = sessionStorage.getItem("cdr");
    setIsCdrPermitted(cdr);
  }, []);

  const logout = () => {
    setTimeout(function () {
      sessionStorage.setItem("tokenStats", "");
      window.location.href = "/";
    }, 3000);
  };
  return (
    <>
      {isCdrPermitted === "true" ? (
        <div className="cdrList">
          <Sidebar />
          <Cdr />
        </div>
      ) : (
        <div>
          <img
            width="100%"
            height="100%"
            src="https://c.tenor.com/ZWopsXeO7tQAAAAd/clapping-applause.gif"
          ></img>
        </div>
      )}
    </>
  );
};

export default CdrList;
